/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { JobCrons } from '../../models/job-crons';

export interface GetJobCrons$Params {}

export function getJobCrons(
   http: HttpClient,
   rootUrl: string,
   params?: GetJobCrons$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<JobCrons>> {
   const rb = new RequestBuilder(rootUrl, getJobCrons.PATH, 'get');
   if (params) {
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<JobCrons>;
      })
   );
}

getJobCrons.PATH = '/api/weather/job/cron';
